import { useState, useEffect } from 'react';

const STORAGE_KEY = 'ai-clinic-theme';
const THEMES = { DARK: 'dark', LIGHT: 'light', SYSTEM: 'system' };

function getSystemTheme() {
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

function applyTheme(preference) {
  const resolved = preference === THEMES.SYSTEM ? getSystemTheme() : preference;
  if (resolved === THEMES.LIGHT) {
    document.documentElement.setAttribute('data-theme', 'light');
  } else {
    document.documentElement.removeAttribute('data-theme');
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || THEMES.DARK;
  });

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  // 监听系统主题变化（当用户选择 system 时）
  useEffect(() => {
    if (theme !== THEMES.SYSTEM) return;
    const mq = window.matchMedia('(prefers-color-scheme: light)');
    const handler = () => applyTheme(THEMES.SYSTEM);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [theme]);

  const setTheme = (newTheme) => {
    localStorage.setItem(STORAGE_KEY, newTheme);
    setThemeState(newTheme);
  };

  const isDark = theme === THEMES.DARK || (theme === THEMES.SYSTEM && getSystemTheme() === 'dark');

  return { theme, setTheme, isDark, THEMES };
}

export function initTheme() {
  const saved = localStorage.getItem(STORAGE_KEY) || THEMES.DARK;
  applyTheme(saved);
}
